<template>
  <tk-container class="dealer" :status="status" @refresh="initData">
    <tkui-header slot="header">
      <tk-flex middle gutter="10" between>
        <tk-icon class="headerIcon unshrink" @click.native="toUser">me</tk-icon>
        <tk-flex class="fill searchBox" middle>
          <tk-flex middle center class="searchIcon">
            <tk-icon>search</tk-icon>
          </tk-flex>
          <div class="fill">
            <input v-model="val" @input="search" class="search" type="text" placeholder="搜索关键词">
          </div>
        </tk-flex>
        <tk-icon @click.native="toWarning">xiaoxi</tk-icon>
      </tk-flex>
    </tkui-header>
    <div v-if="url">
      <tk-image style="width: 100%" :src="url"  :replacement=false></tk-image>
    </div>
    <div class="body">
      <tk-flex v-if="list.length" v-for="(item, index) in list" :key="item.objectId" class="items" @click.native="toDetail(item)">
        <div class="leftBar unshrink full-height" :style="{'background': color1}"></div>
        <div class="app-content">
          <h2 class="itemName">{{user.role === 'admin' ? item.dealerName || item.username || '' : item.username || ''}}</h2>
          <p class="des" v-if="item.role === 'dealer'">{{(item.role === 'dealer' ? item.dealerIntroduce : item.name)|wordAmount}}</p>
          <p v-if="user.role === 'dealer'" class="des">经销商：{{user.dealerName || ''}}</p>
          <tk-flex middle>
            <div class="location unshrink self-bottom">
              <tk-icon style="width: 15px;" :style="{'color':color1}">location</tk-icon>
            </div>
            <span class="address fill">地址：{{(item.role === 'dealer' ? item.dealerAddress : item.projectAddress)|wordAmount}}</span>
          </tk-flex>
        </div>
      </tk-flex>
      <tk-flex v-if="machineRes.length" v-for="(item, index) in machineRes" :key="item.objectId" class="items" @click.native="toMachine(item)">
        <div class="leftBar full-height unshrink" :style="{'background': color2}"></div>
        <div class="app-content">
          <h2 class="itemName">{{item.name}}</h2>
          <p class="des">型号：{{item.type}}</p>
          <tk-flex middle>
            <div class="self-bottom location unshrink">
              <tk-icon style="width: 15px;" :style="{'color':color2}">location</tk-icon>
            </div>
            <span class="address fill">地址：{{item.address|wordAmount}}</span>
          </tk-flex>
        </div>
      </tk-flex>
    </div>
  </tk-container>
</template>

<script>
  export default {
    data () {
      return {
        status: false,
        color1: '#FB7B85',
        color2: '#0091FF',
        val: '',
        list: [],
        machineRes: [],
        res: [],
        machines: [],
        url: ''
      }
    },
    computed: {
      user () {
        return this.$store.state.user || {}
      },
      isData () {
        return !this.list.length && !this.machineRes.length ? 'empty' : false
      }
    },
    async created () {
      this.initData()
      this.getImage()
    },
    methods: {
      async initData () {
        try {
          this.status = 'loading'
          let machines = []
          if (this.user.role && this.user.role === 'admin') {
            let dealers = await this.$tkParse.getList('/users', {
              'params': {
                'where': {
                  'role': 'dealer'
                }
              }
            })
            machines = await this.$tkParse.getList('/classes/machine', {
              'params': {
                'where': {
                  'dealer': {
                    '$exists': false
                  }
                },
                'order': '-createdAt',
                'limit': 2000
              }
            })
            this.list = this.res = dealers
            this.machineRes = this.machines = machines
            this.status = this.isData
            return
          }
          if (this.user.role === 'dealer') {
            let projects = await this.$tkParse.getList('/users', {
              'params': {
                'where': {
                  'belong': this.user.objectId
                },
                'order': '-createdAt',
                'limit': 2000
              }
            })
            machines = await this.$tkParse.getList('/classes/machine', {
              'params': {
                'where': {
                  'dealer': this.user.objectId,
                  'client': {
                    '$exists': false
                  }
                },
                'order': '-createdAt',
                'limit': 2000
              }
            })
            this.list = this.res = projects
            this.machineRes = this.machines = machines
            this.status = this.isData
            return
          }
          if (this.user.role === 'customer') {
            machines = await this.$tkParse.getList('/classes/machine', {
              'params': {
                'where': {
                  'client': this.user.objectId
                },
                'limit': 2000
              }
            })
            this.machineRes = this.machines = machines
          }
          this.status = this.isData
        } catch (e) {
          this.status = 'error'
          this.$tkGlobal.toast.add('获取数据失败')
        }
      },
      async getImage () {
        try {
          let res = await this.$tkParse.getList('/classes/ad')
          if (res[0]) {
            this.url = res[0].url
          }
        } catch (e) {}
      },
      toUser () {
        this.$push('/user')
      },
      toWarning () {
        this.$push('/message')
      },
      toDetail (item) {
        if (this.user.role === 'admin') {
          this.$store.commit('setDealer', item)
          this.$push('/project')
        }
        if (this.user.role === 'dealer') {
          this.$store.commit('setProject', item)
          this.$push('/machines')
        }
      },
      toMachine (machine) {
        this.$store.commit('setMachine', machine)
        this.$push('/detail')
      },
      search () {
        if (!this.val || this.val === '') {
          this.list = this.res
          this.machineRes = this.machines
        } else {
          this.list = this.res.filter((item) => {
            let name = item.dealerName || item.username || item.name
            if (name) {
              return name.includes(this.val)
            }
          })
          this.machineRes = this.machines.filter((item) => {
            return item.name.includes(this.val)
          })
        }
      }
    },
    filters: {
      wordAmount (val) {
        return val && val.length > 18 ? val.substr(0, 18) + '...' : val
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .dealer{
    .headerIcon{
      width: 40px;
    }
    .searchBox{
      background: #1475C4;
      border-radius: 4px;
      .searchIcon{
        width: 40px;
      }
      .search{
        width: 100%;
        height: 34px;
        display: block;
        color: #ffffff;
        font-size: 16px;
        letter-spacing: 1px;
      }
    }
    .body{
      width: 100%;
      padding: 15px;
      box-sizing: border-box;
      .items{
        width: 100%;
        height: 110px;
        background: #ffffff;
        border-radius: 10px;
        overflow: hidden;
        margin-bottom: 15px;
        .leftBar{
          width: 25px;
          border-radius: 50%;
          margin-left: -15px;
        }
        .app-content{
          padding: 15px;
          .itemName{
            font-size: 18px;
            color: #233038;
          }
          .des,.address{
            font-size: 14px;
            color: #999999;
            line-height: 24px;
            margin-top: 4px;
            margin-bottom: 0 !important;
            white-space: nowrap;
          }
          .location{
            width: 20px;
          }
        }
      }
    }
  }
  input::-webkit-input-placeholder {
    color: #ffffff;
    font-size: 16px;
    letter-spacing: 1px;
  }
  input:-moz-placeholder {
    color: #ffffff;
    font-size: 16px;
  }
  input::-moz-placeholder {
    color: #ffffff;
    font-size: 16px;
  }
  input:-ms-input-placeholder {
    color: #ffffff;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/page/app/home/home.vue